export const SET_ERROR = "SET_ERROR";
export const SET_SUCCESS = "SET_SUCCESS";
export const IS_LOADING = "IS_LOADING";
export const SET_PAGE_LOADING = "SET_PAGE_LOADING";
export const SET_DATA_ITEM = "SET_DATA_ITEM";
export const SET_DATA_LIST = "SET_DATA_LIST";
export const SET_TOTAL = "SET_TOTAL";
export const SET_BASE_BOOK = "SET_BASE_BOOK";
export const SET_ADDITIONAL_BOOK_A = "SET_ADDITIONAL_BOOK_A";
export const SET_ADDITIONAL_BOOK_B = "SET_ADDITIONAL_BOOK_B";
export const SET_BASE_PAGE = "SET_BASE_PAGE";
export const SET_BOOK_A_PAGE = "SET_BOOK_A_PAGE";
export const SET_BOOK_B_PAGE = "SET_BOOK_B_PAGE";
